import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';


export const getServiceShopLabour = createAsyncThunk('/GetServiceShopLabour', 
    async (Type) => {
        const response = await axios.get(`/GetServiceShopLabour/${Type}`);
        return response.data;
});

export const setDiscountStepManagement  = createAsyncThunk('/SetDiscountStepManagement', 
    async (data) => {
        const response = await axios.post(`/SetDiscountStepManagement`, data);
        return response.data;
});

export const setServiceShopLabourPriceManagement  = createAsyncThunk('/SetServiceShopLabourPriceManagement', 
    async (data) => {
        const response = await axios.post(`/SetServiceShopLabourPriceManagement`, data);
        return response.data;
});

export const getLaboursForPriceManagement = createAsyncThunk('/GetLaboursForPriceManagement',
    async() => {
        const response = await axios.get('GetLaboursForPriceManagement');
        return response.data;
});

const retailerDiscountSlice = createSlice({
    name: 'retailerDiscount',
    initialState: {
      loading: false,
      error: '',
      ServiceShopLabour: [],
      DiscountStep:[],
      ServiceShopLabourPrice:[],
      labours:[]
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
          .addCase(getServiceShopLabour.pending, (state) => {
            state.loading = true;
          })
          .addCase(getServiceShopLabour.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(getServiceShopLabour.fulfilled, (state, action) => {
            state.ServiceShopLabour = action.payload;
            state.loading = false;
          })
          .addCase(setDiscountStepManagement.pending, (state) => {
            state.loading = true;
          })
          .addCase(setDiscountStepManagement.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(setDiscountStepManagement.fulfilled, (state, action) => {
            state.DiscountStep = action.payload;
            state.loading = false;
          })
          .addCase(setServiceShopLabourPriceManagement.pending, (state) => {
            state.loading = true;
          })
          .addCase(setServiceShopLabourPriceManagement.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(setServiceShopLabourPriceManagement.fulfilled, (state, action) => {
            state.ServiceShopLabourPrice = action.payload;
            state.loading = false;
          })
          .addCase(getLaboursForPriceManagement.pending, (state) => {
            state.loading = true;
          })
          .addCase(getLaboursForPriceManagement.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
          })
          .addCase(getLaboursForPriceManagement.fulfilled, (state, action) => {
            state.labours = action.payload;
            state.loading = false;
          });
    }
});

export const retailerDiscountActions = retailerDiscountSlice.actions;
export default retailerDiscountSlice;